export default {
  supplyPluginList: {
    method: 'post',
    url: '/supply/plugins/list'
  },
  supplyPluginListById: {
    method: 'post',
    url: '/supply/plugins/list/ID'
  },
  supplyPluginCreate: {
    method: 'post',
    url: '/supply/plugins'
  },
  supplyPluginUpdate: {
    method: 'put',
    url: '/supply/plugins'
  },
  supplyPluginDelete: {
    method: 'delete',
    url: '/supply/plugins'
  }
}
